const beginSnow = () => {
  console.log("beginSnow");
  var SnowVolume = 800;
  var elem = document.querySelector(".snow");
  if (!elem) {
    console.error("Snow element not found.");
    return;
  }
  var canvas = document.createElement("canvas");
  var ctx = canvas.getContext("2d");
  var width = elem.clientWidth;
  var height = elem.clientHeight;

  var i = 0;
  var active = false;

  function onResize() {
    width = elem.clientWidth;
    height = elem.scrollHeight;
    // console.log("height----------", elem.scrollHeight);
    canvas.width = width;
    canvas.height = height;
    ctx.fillStyle = "#FFF";
    // ctx.fillStyle = "red";

    var wasActive = active;
    active = width > 200;

    if (!wasActive && active) requestAnimFrame(update);
  }

  var Snowflake = function() {
    this.x = 0;
    this.y = 0;
    this.vy = 0;
    this.vx = 0;
    this.r = 0;

    this.reset();
  };

  Snowflake.prototype.reset = function() {
    // console.log("reset");
    this.x = Math.random() * width;
    this.y = Math.random() * -height;
    // this.vy = 1 + Math.random() * 3;
    // this.vx = 0.5 - Math.random();

    this.vy = 0.5 + Math.random() * 1.5; // 降低雪花垂直速度
    this.vx = 0.25 - Math.random() * 0.5; // 降低雪花水平速度

    this.r = 1 + Math.random() * 2;
    this.o = 0.5 + Math.random() * 0.5;
  };

  canvas.style.position = "absolute";
  canvas.style.left = canvas.style.top = "0";
  canvas.style.pointerEvents = "none";

  var snowflakes = [],
    snowflake;
  for (i = 0; i < SnowVolume; i++) {
    snowflake = new Snowflake();
    snowflake.reset();
    snowflakes.push(snowflake);
  }

  function update() {
    // console.log("update");
    ctx.clearRect(0, 0, width, height);

    if (!active) return;

    for (i = 0; i < SnowVolume; i++) {
      snowflake = snowflakes[i];
      snowflake.y += snowflake.vy;
      snowflake.x += snowflake.vx;

      ctx.globalAlpha = snowflake.o;
      ctx.beginPath();
      ctx.arc(snowflake.x, snowflake.y, snowflake.r, 0, Math.PI * 2, false);
      ctx.closePath();
      ctx.fill();

      if (snowflake.y > height) {
        snowflake.reset();
      }
    }

    // requestAnimFrame(update);
    // setTimeout(() => {
    requestAnimFrame(update);
    // }, 20);
  }

  window.requestAnimFrame = (function() {
    console.log("requestAnimFrame");
    return (
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      function(callback) {
        window.setTimeout(callback, 1000 / 60);
      }
    );
  })();

  onResize();
  window.addEventListener("resize", onResize, false);

  elem.appendChild(canvas);
};

export { beginSnow };
